import Excel from 'exceljs';
import XLSX from "xlsx";
import { parseAsync } from 'json2csv';

const CSV_EXTENSION = ".csv";

export function exportToCsv(tableJson, filename, fields){
  
  let csvFields;
  if (fields && fields.length > 0) {
    csvFields = fields
      .filter(f => f.key && f.label)
      .map(f => ({ label: f.label, value: f.key }));
  } else {
    csvFields = Object.keys(tableJson[0]);
  }

  let opts = { fields: csvFields };
  
  parseAsync(tableJson, opts)
    .then(csv => descargarCsv(csv, filename))
    .catch(err => console.error(err));
    
}

function descargarCsv(csvContent, filename){
  var blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
  let a = document.createElement('a');
        a.setAttribute('download', filename + CSV_EXTENSION);
        a.setAttribute('href', window.URL.createObjectURL(blob));
        a.click();
}
